/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as IconButtonArrayHorizontal } from './icon-button-array-horizontal.story';
export { default as IconButtonArrayVertical } from './icon-button-array-vertical.story';
export { default as IconButtonArrayFloating } from './icon-button-array-floating.story';
export { default as IconButtonArrayCollapsible } from './icon-button-array-collapsible.story';
export { default as IconButtonArraySizes } from './icon-button-array-sizes.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import IconButtonArrayCollapsibleSrcRaw from './icon-button-array-collapsible.story?raw';
import IconButtonArrayFloatingSrcRaw from './icon-button-array-floating.story?raw';
import IconButtonArrayHorizontalSrcRaw from './icon-button-array-horizontal.story?raw';
import IconButtonArraySizesSrcRaw from './icon-button-array-sizes.story?raw';
import IconButtonArrayVerticalSrcRaw from './icon-button-array-vertical.story?raw';

export const IconButtonArrayHorizontalSrc = removeLicenseHeader(
  IconButtonArrayHorizontalSrcRaw,
);
export const IconButtonArrayVerticalSrc = removeLicenseHeader(
  IconButtonArrayVerticalSrcRaw,
);
export const IconButtonArrayFloatingSrc = removeLicenseHeader(
  IconButtonArrayFloatingSrcRaw,
);
export const IconButtonArrayCollapsibleSrc = removeLicenseHeader(
  IconButtonArrayCollapsibleSrcRaw,
);
export const IconButtonArraySizesSrc = removeLicenseHeader(
  IconButtonArraySizesSrcRaw,
);
